<template>
  <div class="mt-3">
    <h1 style="font-size:22px;" class="pl-3">Add Address</h1>

    <v-card-text style="height:auto;">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row class="px-3">
          <v-flex>
            <v-text-field
              v-model="address_name"
              label="Address name"
              :rules="[validation.required]"
              :disabled="isEditCustomer"
            ></v-text-field>
            <v-text-field
              v-model="address"
              :disabled="isEditCustomer"
              label="Address"
              :rules="[validation.required]"
            ></v-text-field>
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-select
                  v-on:change="onChangeProvince"
                  :items="provinceItems"
                  v-model="province_add_id"
                  item-text="province_name_th"
                  item-value="province_id"
                  label="Province"
                  :rules="[validation.required]"
                  :disabled="isEditCustomer"
                ></v-select>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <v-select
                  :items="districtItems"
                  v-on:change="onChangeDistrict"
                  v-model="district_add_id"
                  item-text="district_name_th"
                  item-value="district_id"
                  label="District"
                  :rules="[validation.required]"
                  :disabled="isEditCustomer"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-select
                  :items="subDistrictItems"
                  v-model="subDistrict_add_id"
                  item-text="sub_district_name_th"
                  item-value="sub_district_id"
                  label="Sub district"
                  :rules="[validation.required]"
                  :disabled="isEditCustomer"
                ></v-select>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <v-select
                  :items="postcodeItems"
                  v-model="zipcode_add_id"
                  item-text="zipcode_code"
                  item-value="zipcode_id"
                  label="Post Code"
                  :rules="[validation.required]"
                  :disabled="isEditCustomer"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-textarea
              v-model="address_note"
              name="note"
              label="Place Note"
              value
              hint="Hint text"
              :disabled="isEditCustomer"
              rows="1"
            ></v-textarea>
            <v-layout row>
              <v-flex xs6 class="mr-2">
                <v-text-field
                  v-model="address_lat"
                  :rules="[rules.required,rules.onlyDouble]"
                  :disabled="isEditCustomer"
                  label="latitude"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="ml-2">
                <v-text-field
                  v-model="address_long"
                  :rules="[rules.required,rules.onlyDouble]"
                  :disabled="isEditCustomer"
                  label="longitude"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-btn @click="change_location++" :disabled="isEditCustomer">Update map</v-btn>
            <v-card height="auto" width="auto" color="grey">
              <GoogleMap
                :latitude="parseFloat(address_lat)"
                :longitude="parseFloat(address_long)"
                :change="change_location"
                :height="400"
                :zoom="15"
                :mapType="'all'"
                :draggable="true"
                @draged="getDragLocation($event)"
              ></GoogleMap>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" flat :disabled="isEditCustomer">Clear</v-btn>
      <v-btn color="green" flat @click="add()" :disabled="isEditCustomer">Add</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["selectedCustomer"],
  data() {
    return {
      address_name: null,
      rules: {
        onlyDouble: value => {
          const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
          return pattern.test(value) || "Invalid";
        },
        required: value => !!value || "Required."
      },
      change_location: 0,
      address_note: "",
      valid: true,
      address: "",
      address_lat: 0,
      address_long: 0,
      province_add_id: null,
      district_add_id: null,
      subDistrict_add_id: null,
      zipcode_add_id: null,
      validation: {
        required: value => !!value || "Required."
      }
    };
  },
  computed: {
    ...mapState({
      provinceItems: state => state.fetchCustomerBack.provinceAdd,
      districtItems: state => state.fetchCustomerBack.districtAdd,
      subDistrictItems: state => state.fetchCustomerBack.subDistrictAdd,
      postcodeItems: state => state.fetchCustomerBack.zipcodeAdd
    }),
    ...mapGetters(["isEditCustomer"])
  },
  methods: {
    getDragLocation(val) {
      this.address_lat = val.lat;
      this.address_long = val.lng;
    },
    onChangeDistrict() {
      this.subDistrict_add_id = null;
      this.zipcode_add_id = null;
      this.$store.dispatch(
        "fetchCustomerBack/getSubDistrictAdd",
        this.district_add_id
      );
      this.$store.dispatch(
        "fetchCustomerBack/getZipCodeAdd",
        this.district_add_id
      );
    },
    onChangeProvince() {
      this.subDistrict_add_id = null;
      this.district_add_id = null;
      this.zipcode_add_id = null;
      this.$store.dispatch(
        "fetchCustomerBack/getDistrictAdd",
        this.province_add_id
      );
    },
    add() {
      if (this.$refs.form.validate()) {
        const info = {
          user_address_default: 0,
          user_address_contact_tel: "",
          user_address_text: this.address,
          user_address_lat: this.address_lat,
          user_address_long: this.address_long,
          user_address_sub_district: this.subDistrict_add_id,
          user_address_district: this.district_add_id,
          user_address_province: this.province_add_id,
          user_address_zipcode: this.zipcode_add_id,
          user_address_user: this.selectedCustomer.user_id,
          user_address_note: this.address_note == "" ? null : this.address_note,
          user_address_name: this.address_name
        };

        this.$store.dispatch("fetchCustomerBack/addCustomerAddress", info);
        this.clear();
      }
    },
    clear() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style>
</style>
